import { put } from 'redux-saga/effects';
import { apiPost } from 'shared/api';
import * as actions from 'store/actions';
import { fetchUserProfile } from 'store/thunks';

// Migrated to thunks/auth
// userSessionSaga => getUserSession

// Migrated to thunks/auth
// authCheckLoginStateSaga => authCheckLogin

// Migrated to thunks/user
// signUpUserSaga => signUpUser

export function* verifyAccountSaga(action) {
  console.log('verifyAccountSaga');
  yield put(actions.verifyAccountStart());
  try {
    const data = {
      UserId: action.UserId,
      Code: action.Code,
      GetSession: true,
    };
    const response = yield apiPost('v2_userVerify', data);
    const sessionToken = yield response.data.payload.SessionToken;
    yield put(actions.verifyAccountSuccess(sessionToken, response.data.payload.Verified));
    if (response.data.payload.Verified === 'Email' && sessionToken) {
      yield localStorage.setItem('sessionToken', sessionToken);
    }
    yield put(fetchUserProfile(false, action.UserId, 'signedInAs', true));

    yield put(actions.clearAppError());
  } catch (error) {
    yield put(actions.verifyAccountFailed(error.response.data.error_message));
  }
}

export function* resendAccountVerificationCodeSaga(action) {
  console.log('resendAccountVerificationCodeSaga');
  yield put(actions.resendAccountVerificationCodeStart());
  try {
    const data = {
      UserId: action.UserId,
    };
    if (action.Verify) {
      data.Verify = action.Verify;
    }
    const response = yield apiPost('v2_userRegisterResendVerify', data);
    yield put(actions.resendAccountVerificationCodeSuccess(response.data.payload.CodeSentTo));
  } catch (error) {
    yield put(actions.resendAccountVerificationCodeFailed(error.response.data.error_message));
  }
}

export function* signInUserSaga(action) {
  console.log('signInUserSaga');
  yield put(actions.signInStart());
  try {
    const data = { AppKey: 'desktop' };
    if (action.Email) {
      data.Email = action.Email;
    }
    if (action.Password) {
      data.Pass = action.Password;
    }
    if (action.TempPass) {
      data.TempPass = action.TempPass;
    }
    const response = yield apiPost('v3_userSignin', data);
    const user = yield response.data.payload.User.User;
    const skinTones = JSON.parse(localStorage.getItem('skinTones') || '{}');
    const emojiSkinTone = skinTones[user.UserId] ? skinTones : { [user.UserId]: 1 };
    const logs = yield response.data.payload.Logs ? response.data.payload.Logs.Logs : [];
    const groups = yield response.data.payload.Groups ? response.data.payload.Groups.Groups : [];
    const managedUsers = yield response.data.payload.ManagedUsers === false ? [] : response.data.payload.ManagedUsers.ManagedUsers;
    const giftsDraftsCount = response.data.payload.DraftSummary
      ? response.data.payload.DraftSummary.DraftCount + response.data.payload.DraftSummary.DraftGiftCount
      : 0;
    const knownUsers = yield response.data.payload.KnownUsers;
    const sessionToken = yield response.data.payload.SessionToken;
    localStorage.setItem('signedInAs', JSON.stringify({ UserId: user.UserId }));
    localStorage.setItem('postingAs', JSON.stringify({ UserId: user.UserId }));
    localStorage.setItem('sessionToken', sessionToken);
    localStorage.removeItem('codeSentTo');
    yield put(actions.signInSuccess(user.UserId, response.data.payload.ForceNewPassword, sessionToken));
    yield put(actions.clearAppError());
    yield put(actions.fetchProfileSuccess(user, logs, managedUsers, groups, false, 'signedInAs', giftsDraftsCount, knownUsers, true, emojiSkinTone));
  } catch (error) {
    // if (error.response.data.error_code === 10) {
    // }
    let accountVerified = true;
    let codeSentTo = null;
    let userId = null;
    // Here we handle the case where a user attempts to sign in without having yet verified their email/phone number.
    // In this case, we'll take them to the Verification screen.
    if (error.response.data.error_data && error.response.data.error_data.user === 'NotVerified') {
      accountVerified = false;
      codeSentTo = error.response.data.error_data.verify;
      userId = error.response.data.error_data.UserId;
      if (userId) {
        localStorage.setItem('codeSentTo', codeSentTo);
        yield localStorage.setItem('signedInAs', JSON.stringify({ UserId: userId }));
        yield localStorage.setItem('postingAs', JSON.stringify({ UserId: userId }));
      }
    }
    yield put(actions.signInFailed(error.response.data.error_message, accountVerified, codeSentTo, userId));
  }
}

export function* requestPasswordResetSaga(action) {
  console.log('requestPasswordResetSaga');
  yield put(actions.requestPasswordResetStart());
  try {
    const response = yield apiPost('v2_userPassReset', {
      Email: action.Email,
      AppKey: 'desktop',
    });
    const successMessage = yield response.data.success_message;
    yield put(actions.requestPasswordResetSuccess(successMessage));
  } catch (error) {
    yield put(actions.requestPasswordResetFailed(error.response.data.error_message));
  }
}

export function* logoutSaga(action) {
  console.log('requestPasswordResetSaga');
  const sessionToken = yield localStorage.getItem('sessionToken');
  if (sessionToken) {
    yield put(actions.logoutStart());
    localStorage.removeItem('sessionToken');
    if (localStorage.getItem('UserId')) {
      localStorage.removeItem('UserId');
    }
    if (localStorage.getItem('selectedServer') !== null) {
      localStorage.removeItem('selectedServer');
      yield put(actions.setSelectedServerSuccess(null));
    }
    localStorage.removeItem('signedInAs');
    localStorage.removeItem('postingAs');
    localStorage.removeItem('logFilters');
    localStorage.removeItem('logSortBy');
    localStorage.removeItem('selectedColumns');
    localStorage.removeItem('postViewSize');
    localStorage.removeItem('codeSentTo');
    if (localStorage.getItem('managedUsers')) {
      localStorage.removeItem('managedUsers');
    }
    if (!action.isAutoLogout) {
      try {
        yield apiPost('v2_userSignout', {});
      } catch (error) {
        yield put(actions.logoutFailed(error.response.data.error_message));
      }
    }
    yield put(actions.logoutSuccess());
  }
}
